<template>
  <HeaderGame />
  <div id="container">

    <div class="main">
      <div class="swiper-container slide-new">
        <div class="swiper-wrapper">
          <van-swipe :autoplay="3000" indicator-color="#4992ff">
            <van-swipe-item v-for="(game, index) in bannerList" :key="index">
              <div class="banner-card">
                <h2>{{ game.title }}</h2>
                <p>{{ game.content }}</p>
                <img class="banner-img" :src="game.bannerImg" alt="" @click="onStartGame(game.id)" />
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>

      <section id="hot-game" class="game-list-section">
        <div class="game-tab-bar">
          <a href="javascript:void(0)" class="active">精选</a>
          <!-- <a href="https://h.zixia.com/class/?tag=-2" onclick="goclass(-2,this)">新游</a>
          <a href="https://h.zixia.com/class/?tag=5" onclick="goclass(5,this)">仙侠</a>
          <a href="https://h.zixia.com/class/?tag=7" onclick="goclass(7,this)">传奇</a> -->
        </div>

        <div class="game-list-container">
          <article class="game-item" v-for="(game, index) in gameList" :key="index">
            <a class="game-info">
              <img v-lazy="game.iconImg" class="game-icon" alt="" />
              <div class="game-text">
                <h3 class="game-title">{{ game.title }}</h3>
                <p style="display: flex;">
                  <span class="game-tag" v-for="(tag, tagindex) in game.tags" :key="tagindex"
                    :style="{ backgroundColor: tag.color }">
                    {{ tag.label }}
                  </span>
                </p>
                <p class="game-desc">{{ game.content }}</p>
              </div>
            </a>
            <a class="play-btn" target="_top" @click.stop="onStartGame(game.id)">秒开</a>
          </article>
        </div>
      </section>
    </div>
  </div>

  <!-- <DownLoadApply /> -->

  <van-row justify="center">
    <van-col :span="24">
      <nav-bar />
    </van-col>
  </van-row>
</template>

<script>
import { reactive, onMounted, toRefs } from "vue";
import { useRouter } from "vue-router";
import NavBar from '@/components/NavBar'
import HeaderGame from '@/components/HeaderGame'
// import { Toast } from 'vant'
import { requestGameList, packname } from "@/service/web";
import { validatenull } from '@/utils/validate';
import { useStore } from 'vuex'
// import { useI18n } from 'vue-i18n'
// import DownLoadApply from '@/components/DownLoadApply'

export default {
  name: "game",
  setup() {
    const router = useRouter();
    const store = useStore();
    // const { t } = useI18n() 
    
    const state = reactive({
      bannerList: [],
      gameList: [],
      loginState: false,
    });

    onMounted(() => {
      init();
      install();
      alreadyLogged();
    });

    const init = async () => {
      store.commit("setNeedLogin", false);

      let result = await requestGameList();
      state.gameList = result.gameList;

      for (const game of state.gameList) {
        console.log(game)
        if (!validatenull(game.bannerImg) && game.bannerStatus == 1) {
          state.bannerList.push(game);
        }

        game.tags = [];
        if (!validatenull(game.label)) {
          let list = game.label.split('|');
          for (let i = 0; i < list.length; i++) {
            let label = list[i].split(',');
            game.tags.push({
              color: label[0],
              label: label[1],
            })
          }
        }
      }
    };

    const onStartGame = (boxId) => {
      // store.commit("setNeedLogin", true);
      // goTo("/ldy/squeezePlay", { id: game })
      // const isLogin = store.getters.isLogin;
      // if (isLogin) {
      //   goTo("/gameplay/", {
      //     id: gameId,
      //     url: gameUrl
      //   })
      // } else {
      //   store.commit("setNeedLogin", true);
      // }
      goTo("/gameplay/", {
        id: boxId,
      })
    }

    const onDownLoad = (url) => {
      const isLogin = store.getters.isLogin;
      if (!isLogin || isLogin == "false") {
        store.commit("setNeedLogin", true)
      } else {
        window.open(url);
      }
    }

    const goTo = (url, params) => {
      router.push({ path: url, query: params })
    }

    const onpeLdy = async (id) => {
      let result = await packname(id);
      if (result.data) {
        goTo("/store/apps/details", { id: result.data })
      }
    }

    const install = () => {
      state.installShow = true;
    }

    const login = () => {
      store.commit("setNeedLogin", true);
    }

    const skipUserCenter = () => {
      goTo("/my", {});
    }

    const alreadyLogged = () => {
      var isLogin = store.getters.isLogin;
      state.loginState = isLogin ? false : true;
    }

    return {
      ...toRefs(state),
      onStartGame,
      onDownLoad,
      onpeLdy,
      login,
      skipUserCenter
    };
  },
  components: {
    NavBar,
    HeaderGame,
    // DownLoadApply
  },
};
</script>

<style lang="less" scoped>
/* 全局基础样式 */
.main {
  max-width: 640px;
  margin: 0 auto;
  // min-height: 100vh;
  background: #f2f5fa;
  // overflow: visible !important; /* 修复：允许滚动 */
  height: calc(var(--vh, 1vh) * 95);
  padding-bottom: 70px;
  /* 给底部导航留空间 */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  /* 隐藏滚动条（核心三行） */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE / Edge */
}

/* Chrome / Safari / 新版Edge */
.game-content::-webkit-scrollbar {
  display: none;
}

/* 轮播图区域 */
.slide-new {
  margin: 12px 12px 16px;

  .banner-card {
    width: 100%;
    position: relative;
  }

  h2 {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    margin: 0 0 4px 2px;
    text-align: left;
  }

  p {
    font-size: 12px;
    color: #777;
    margin: 0 0 10px 2px;
    text-align: left;
  }

  .banner-img {
    width: 100%;
    // height: 180px;
    border-radius: 12px;
    object-fit: cover;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    cursor: pointer;
    transition: transform 0.2s ease;

    &:active {
      transform: scale(0.98);
    }
  }
}

/* 游戏列表区域 */
.game-list-section {
  margin: 0 12px;
}

/* 标签栏 */
.game-tab-bar {
  display: flex;
  align-items: center;
  height: 45px;
  background: #fff;
  border-radius: 12px 12px 0 0;
  padding: 0 15px;
  position: relative;
  overflow: hidden;

  a {
    flex: 1;
    font-size: 15px;
    color: #8e8e8e;
    text-align: left;
    transition: color 0.2s;
    z-index: 5;

    &.active {
      font-size: 19px;
      font-weight: bold;
      color: #171917;
    }
  }

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 30%;
    height: 100%;
    background: linear-gradient(180deg, #d6e6ff 0%, #fff 100%);
    border-radius: 10px 0 60px 0;
    z-index: 0;
  }
}

/* 游戏列表容器 */
.game-list-container {
  background: #fff;
  border-radius: 0 0 12px 12px;
  overflow: visible;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

/* 游戏项 */
.game-item {
  position: relative;
  padding: 12px 15px;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
  align-items: center;
  transition: background 0.2s;

  &:last-child {
    border-bottom: none;
  }

  &:active {
    background: #f9f9f9;
  }

  .game-tag {
    color: #feeff0;
    display: inline-block;
    text-transform: uppercase;
    font-size: 12px;
    text-align: left;
    line-height: 1em;
    border-radius: 5px;
    padding: 0 5px;
    height: 18px;
    line-height: 18px;
    margin-left: 2px;
  }

  .game-icon {
    width: 60px;
    height: 60px;
    border-radius: 14px;
    object-fit: cover;
    flex-shrink: 0;
  }

  .game-info {
    display: flex;
    align-items: center;
    flex: 1;
  }

  .game-text {
    margin-left: 12px;
    flex: 1;
    overflow: hidden;
  }

  .game-title {
    font-size: 15px;
    text-align: left;
    font-weight: 500;
    color: #171917;
    margin: 0 0 5px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .game-desc {
    font-size: 12px;
    color: #999;
    margin: 0;
    margin-top: 5px;
    // white-space: w;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
  }

  /* 秒开按钮 */
  .play-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 70px;
    height: 32px;
    line-height: 32px;
    background: #6387ea;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    border-radius: 16px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(73, 146, 255, 0.3);
    transition: all 0.2s ease;
    position: relative;
    flex-shrink: 0;

    &::after {
      content: "";
      position: absolute;
      right: 10px;
      top: 12px;
      width: 6px;
      height: 6px;
      border-top: 2px solid #fff;
      border-right: 2px solid #fff;
      transform: rotate(45deg);
    }

    &:hover {
      background: #3a82ee;
      box-shadow: 0 3px 10px rgba(73, 146, 255, 0.4);
    }

    &:active {
      transform: scale(0.96);
    }
  }
}
</style>